(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    if (!customElements.get('nav-menu')) {
      customElements.define('nav-menu', NavMenu);
    }

    const desktopQuery = window.matchMedia(theme.mediaQueries.md);
    let lockedTopLevelDetails = null;
    let lockedChildDetails = null;

    function isDesktop() {
      return desktopQuery.matches;
    }

    function getMainMenu() {
      return document.querySelector('.cc-header main-menu.main-menu');
    }

    function closeNavigationOverlay() {
      const mainMenu = getMainMenu();

      if (mainMenu && typeof mainMenu.toggleOverlay === 'function') {
        mainMenu.toggleOverlay(false);
      } else {
        const overlay = document.querySelector('.js-overlay');
        if (overlay) {
          overlay.classList.remove('overlay--nav', 'is-visible');
        }
      }

      document.body.classList.remove('overflow-hidden', 'fixed');
      document.documentElement.classList.remove('overflow-hidden', 'fixed');

      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('width');

      if (mainMenu) {
        mainMenu.overlayOpen = false;
        mainMenu.childNavOpen = false;
      }

      if (window.removeTrapFocus) {
        window.removeTrapFocus();
      }
    }

    function syncPromotedDropdownTop() {
      if (!isDesktop()) return;

      const desktopMainMenu = document.querySelector('.cc-header .header__grid > main-menu.main-menu');
      if (!desktopMainMenu) return;

      const top = Math.round(desktopMainMenu.getBoundingClientRect().top);

      document
        .querySelectorAll('.cc-header .header__promoted-nav .main-nav__child')
        .forEach((panel) => {
          panel.style.top = `${top}px`;
        });
    }

    function syncDesktopNavRows() {
      const nav = document.querySelector('.cc-header .main-nav--desktop-primary');
      if (!nav) return;

      const items = Array.from(nav.children).filter((item) => item.matches('li'));

      items.forEach((item) => {
        item.classList.remove('main-nav__row-start', 'main-nav__row-end');

        const panel = item.querySelector(':scope > details > .main-nav__child:not(.mega-nav)');
        if (panel) {
          panel.classList.remove('main-nav__child--offset-right');
        }
      });

      if (!isDesktop()) return;

      const rows = [];

      items.forEach((item) => {
        const rect = item.getBoundingClientRect();
        const row = rows.find((existingRow) => Math.abs(existingRow.top - rect.top) <= 4);

        if (row) {
          row.items.push({ item, rect });
        } else {
          rows.push({
            top: rect.top,
            items: [{ item, rect }]
          });
        }
      });

      rows.forEach((row) => {
        row.items.sort((a, b) => a.rect.left - b.rect.left);

        const firstItem = row.items[0].item;
        const lastItem = row.items[row.items.length - 1].item;

        firstItem.classList.add('main-nav__row-start');
        lastItem.classList.add('main-nav__row-end');
      });

      items.forEach((item) => {
        const panel = item.querySelector(':scope > details > .main-nav__child:not(.mega-nav)');
        if (!panel) return;

        const itemRect = item.getBoundingClientRect();
        const estimatedDropdownWidth = 300;
        const wouldOverflowRight = itemRect.left + estimatedDropdownWidth > window.innerWidth;

        if (wouldOverflowRight) {
          panel.classList.add('main-nav__child--offset-right');
        }
      });
    }

    function highlightMobileAllLinks() {
      if (isDesktop()) return;

      document
        .querySelectorAll('.cc-header .main-nav--mobile-replacement a')
        .forEach((link) => {
          const label = link.textContent.trim().replace(/\s+/g, ' ');

          if (/^All\s+/i.test(label)) {
            link.style.setProperty('color', '#ac8e60', 'important');

            link.querySelectorAll('svg').forEach((icon) => {
              icon.style.setProperty('color', '#ac8e60', 'important');
              icon.style.setProperty('stroke', '#ac8e60', 'important');
            });
          }
        });
    }

    function setLockedOpen(details) {
      details.open = true;
      details.classList.add('is-open');
      details.classList.add('is-clicked-open');
      details.classList.add('mega-nav-open');
      highlightMobileAllLinks();
    }

    function clearLockedOpen(details) {
      window.clearTimeout(details.promotedCloseTimeout);
      details.open = false;
      details.classList.remove('is-open');
      details.classList.remove('is-closing');
      details.classList.remove('is-clicked-open');
      details.classList.remove('mega-nav-open');
    }

    function clearTopLevelLocks(exceptDetails = null) {
      document.querySelectorAll('.cc-header .main-menu .main-nav > li > details').forEach((details) => {
        if (details !== exceptDetails) {
          clearLockedOpen(details);
        }
      });
    }

    function clearChildLocks(exceptDetails = null) {
      document.querySelectorAll('.cc-header .child-nav--dropdown details').forEach((details) => {
        if (details !== exceptDetails) {
          clearLockedOpen(details);
        }
      });
    }

    function clearAllLocks() {
      clearTopLevelLocks();
      clearChildLocks();

      document.querySelectorAll('.cc-header .header__promoted-nav .main-nav > li > details').forEach((details) => {
        clearLockedOpen(details);
      });

      lockedTopLevelDetails = null;
      lockedChildDetails = null;
      closeNavigationOverlay();

      document.body.classList.remove('overflow-hidden', 'fixed');
      document.documentElement.classList.remove('overflow-hidden', 'fixed');
    }

    function closeOtherPromotedDetails(exceptDetails = null) {
      document.querySelectorAll('.cc-header .header__promoted-nav .main-nav > li > details').forEach((details) => {
        if (details !== exceptDetails) {
          clearLockedOpen(details);
        }
      });

      if (lockedTopLevelDetails && lockedTopLevelDetails !== exceptDetails) {
        lockedTopLevelDetails = null;
      }
    }

    function openPromotedDetails(details) {
      closeOtherPromotedDetails(details);
      clearTopLevelLocks();
      clearChildLocks();

      details.open = true;
      details.classList.remove('is-closing');
      details.classList.add('is-open');

      const visibleSidebarItem = details.querySelector('.mega-nav--sidebar .js-sidebar-hover.is-visible');
      const firstSidebarItem = details.querySelector('.mega-nav--sidebar .js-sidebar-hover');
      if (!visibleSidebarItem && firstSidebarItem) {
        setPromotedSidebarVisible(firstSidebarItem);
      }

      highlightMobileAllLinks();
    }

    function closePromotedDetails(details) {
      details.classList.remove('is-open');
      details.classList.remove('is-closing');
      details.open = false;

      if (!document.querySelector('.cc-header details.is-open, .cc-header details.is-clicked-open')) {
        closeNavigationOverlay();
      }
    }

    function schedulePromotedClose(details) {
      window.clearTimeout(details.promotedCloseTimeout);
      details.promotedCloseTimeout = window.setTimeout(() => {
        if (!details.classList.contains('is-clicked-open')) {
          closePromotedDetails(details);
        }
      }, 250);
    }

    function cancelPromotedClose(details) {
      window.clearTimeout(details.promotedCloseTimeout);
    }

    function setPromotedSidebarVisible(sidebarItem) {
      const container = sidebarItem.closest('.child-nav');
      if (!container) return;

      const visibleItem = container.querySelector('.js-sidebar-hover.is-visible');
      if (visibleItem && visibleItem !== sidebarItem) {
        visibleItem.classList.remove('is-visible');
      }

      sidebarItem.classList.add('is-visible');

      const navMenu = sidebarItem.closest('nav-menu');
      const disclosurePanel = navMenu ? navMenu.querySelector('.disclosure__panel') : null;
      if (disclosurePanel) {
        container.style.setProperty(
          '--sidebar-height',
          `${Number.parseInt(disclosurePanel.getBoundingClientRect().height, 10)}px`
        );
      }

      highlightMobileAllLinks();
    }

    syncPromotedDropdownTop();
    syncDesktopNavRows();
    highlightMobileAllLinks();

    window.addEventListener('resize', () => {
      syncPromotedDropdownTop();
      syncDesktopNavRows();
      highlightMobileAllLinks();
    });

    window.addEventListener('scroll', syncPromotedDropdownTop, { passive: true });

    document.addEventListener('click', function(event) {
      window.setTimeout(highlightMobileAllLinks, 0);

      if (!isDesktop()) return;

      const topLevelLink = event.target.closest('.cc-header .main-menu .main-nav > li > details > summary > .main-nav__item');

      if (topLevelLink) {
        const topLevelDetails = topLevelLink.closest('details');
        if (!(topLevelDetails instanceof HTMLDetailsElement)) return;

        event.preventDefault();
        event.stopPropagation();

        if (lockedTopLevelDetails === topLevelDetails && topLevelDetails.classList.contains('is-clicked-open')) {
          window.location.href = topLevelLink.href;
          return;
        }

        closeOtherPromotedDetails();
        clearTopLevelLocks(topLevelDetails);
        clearChildLocks();
        setLockedOpen(topLevelDetails);
        lockedTopLevelDetails = topLevelDetails;
        lockedChildDetails = null;

        syncPromotedDropdownTop();
        syncDesktopNavRows();
        return;
      }

      const childLink = event.target.closest('.cc-header .child-nav--dropdown details > .child-nav__item--toggle .child-nav__item');

      if (childLink) {
        const childDetails = childLink.closest('details');
        if (!(childDetails instanceof HTMLDetailsElement)) return;

        if (lockedChildDetails === childDetails && childDetails.classList.contains('is-clicked-open')) {
          event.preventDefault();
          event.stopPropagation();
          window.location.href = childLink.href;
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        clearChildLocks(childDetails);
        setLockedOpen(childDetails);
        lockedChildDetails = childDetails;
        return;
      }

      const clickedInsideMenu = event.target.closest('.cc-header main-menu, .cc-header .header__promoted-nav');
      if (!clickedInsideMenu) {
        clearAllLocks();
      }
    });

    document.querySelectorAll('.cc-header .main-menu .main-nav > li > details').forEach((details) => {
      const li = details.closest('li');
      if (!li) return;

      li.addEventListener('mouseenter', function() {
        if (!isDesktop()) return;

        closeOtherPromotedDetails();
        clearTopLevelLocks(details);
        clearChildLocks();

        lockedTopLevelDetails = null;
        lockedChildDetails = null;

        syncDesktopNavRows();
      });
    });

    document.querySelectorAll('.cc-header .header__promoted-nav .mega-nav--sidebar .js-sidebar-hover').forEach((sidebarItem) => {
      sidebarItem.addEventListener('mouseenter', function() {
        if (!isDesktop()) return;

        const topLevelDetails = sidebarItem.closest('.header__promoted-nav .main-nav > li > details');
        if (topLevelDetails) {
          cancelPromotedClose(topLevelDetails);
          openPromotedDetails(topLevelDetails);
        }

        setPromotedSidebarVisible(sidebarItem);
      });

      sidebarItem.addEventListener('click', function(event) {
        if (!isDesktop()) return;
        if (!sidebarItem.closest('summary')) return;

        event.preventDefault();
        event.stopPropagation();

        const topLevelDetails = sidebarItem.closest('.header__promoted-nav .main-nav > li > details');
        if (topLevelDetails) {
          cancelPromotedClose(topLevelDetails);
          openPromotedDetails(topLevelDetails);
        }

        setPromotedSidebarVisible(sidebarItem);
      });
    });

    document.querySelectorAll('.cc-header .header__promoted-nav .main-nav > li > details').forEach((details) => {
      const li = details.closest('li');

      if (li) {
        li.addEventListener('mouseenter', function() {
          if (!isDesktop()) return;
          if (details.classList.contains('is-clicked-open')) return;

          cancelPromotedClose(details);
          syncPromotedDropdownTop();
          openPromotedDetails(details);
        });

        li.addEventListener('mouseleave', function() {
          if (!isDesktop()) return;
          if (details.classList.contains('is-clicked-open')) return;

          schedulePromotedClose(details);
        });
      }

      const panel = details.querySelector('.main-nav__child');
      if (panel) {
        panel.addEventListener('mouseenter', function() {
          if (!isDesktop()) return;
          if (details.classList.contains('is-clicked-open')) return;

          cancelPromotedClose(details);
          openPromotedDetails(details);
        });

        panel.addEventListener('mouseleave', function() {
          if (!isDesktop()) return;
          if (details.classList.contains('is-clicked-open')) return;

          schedulePromotedClose(details);
        });
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        clearAllLocks();
      }
    });

    desktopQuery.addEventListener('change', function() {
      clearAllLocks();
      syncPromotedDropdownTop();
      syncDesktopNavRows();
      highlightMobileAllLinks();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
